import { EventEmitter, Component, Output, Input, OnInit, HostListener,
  OnDestroy, ElementRef, ViewChild, AfterViewInit, Renderer2, OnChanges, SimpleChanges } from '@angular/core';
import { ViwerService } from './services/viewerService/viwer-service';
import { PlayerConfig } from './sunbird-epub-player.interface';
import { EpubPlayerService } from './sunbird-epub-player.service';
import { epubPlayerConstants, pageId, telemetryType } from './sunbird-epub.constant';
import { ErrorService, errorCode, errorMessage } from '@project-sunbird/sunbird-player-sdk-v9';
import { UtilService } from './services/utilService/util.service';
import { NextContent } from '@project-sunbird/sunbird-player-sdk-v9/sunbird-player-sdk.interface';
import { HttpClient, HttpHeaders} from "@angular/common/http";
import { ToastrService } from './services/toastService/toastr.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'sunbird-epub-player',
  templateUrl: './sunbird-epub-player.component.html',
  styleUrls: ['./sunbird-epub-player.component.scss']
})
export class EpubPlayerComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  fromConst = epubPlayerConstants;
  @ViewChild('epubPlayer', { static: true }) epubPlayerRef: ElementRef;
  @Input() playerConfig: PlayerConfig;
  @Input() showFullScreen = false;
  @Output() headerActionsEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() telemetryEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() playerEvent: EventEmitter<object>;
  private unlistenMouseEnter: () => void;
  private unlistenMouseLeave: () => void;
  public showControls = true;
  public validPage = true;
  showContentError: boolean;
  sideMenuConfig = {
    showShare: false,
    showDownload: false,
    showReplay: false,
    showExit: false,
    showPrint: false
  };
  urlTTS: string = 'https://dhruva-api.bhashini.gov.in/services/inference/pipeline';
  urlDetectLang:string = 'https://dhruva-api.bhashini.gov.in/services/inference/txtlangdetection';
  audio: any = '';
  audioQueue: any[] = [];
  playerState = { isPlaying: false };
  counter: number = 0;
  loading: boolean = false;
  chunks=[]
  isStreamIntrupted: boolean =false;
  private cancelRequests$ = new Subject<void>();
  languageList =[
    {languageCode:'en',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'hi',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'as',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'bn',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'gu',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'kn',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'mr',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'or',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'pa',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'ta',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'te',modelId: 'Bhashini/IITM/TTS'},
    {languageCode:'ur',modelId: 'Bhashini/IITM/TTS'}
  ]
  public isInitialized = false;
  viewState = this.fromConst.LOADING;
  intervalRef: any;
  progress = 0;
  showEpubViewer: boolean;
  public traceId: string;
  currentPageIndex = 1;
  headerConfiguration = {
    rotation: false,
    goto: true,
    navigation: true,
    zoom: false
  };

  nextContent: NextContent;
  playbackRate: number = 1.0;
  langCode: string='';
  currentPageNo: number;
  mimeType: any;
  constructor(
    public viwerService: ViwerService,
    private epubPlayerService: EpubPlayerService,
    public errorService: ErrorService,
    public utilService: UtilService,
    private renderer2: Renderer2,
    public http: HttpClient,
    private toastrService: ToastrService
  ) {
    this.playerEvent = this.viwerService.playerEvent;
  }

  @HostListener('document:TelemetryEvent', ['$event'])
  onTelemetryEvent(event) {
    this.telemetryEvent.emit(event.detail);
  }

  async ngOnInit() {
    this.mimeType = _.get(this.playerConfig, 'metadata.mimeType')
    this.isInitialized = true;
    if (this.playerConfig) {
    if (typeof this.playerConfig === 'string') {
      try {
        this.playerConfig = JSON.parse(this.playerConfig);
      } catch (error) {
        console.error('Invalid playerConfig: ', error);
      }
    }
  }
    // initializing services
    this.viwerService.initialize(this.playerConfig);
    this.epubPlayerService.initialize(this.playerConfig);
    this.traceId = this.playerConfig?.config?.traceId;


    // checks online error while loading epub
    if (!navigator.onLine && !this.viwerService.isAvailableLocally) {
      // tslint:disable-next-line:max-line-length
      this.viwerService.raiseExceptionLog(errorCode.internetConnectivity, this.currentPageIndex, errorMessage.internetConnectivity, this.traceId, new Error(errorMessage.internetConnectivity));
    }

    // checks content compatibility error
    const contentCompabilityLevel = this.playerConfig?.metadata?.compatibilityLevel;
    if (contentCompabilityLevel) {
      const checkContentCompatible = this.errorService.checkContentCompatibility(contentCompabilityLevel);
      if (!checkContentCompatible?.isCompitable) {
        // tslint:disable-next-line:max-line-length
        this.viwerService.raiseExceptionLog(errorCode.contentCompatibility, this.currentPageIndex, errorCode.contentCompatibility, this.traceId, checkContentCompatible.error);
      }
    }

    this.showEpubViewer = true;
    this.sideMenuConfig = { ...this.sideMenuConfig, ...this.playerConfig.config.sideMenu };
    this.getEpubLoadingProgress();
    this.nextContent = this.playerConfig.config.nextContent;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showFullScreen && !changes?.showFullScreen?.firstChange) {
      this.showFullScreen = changes.showFullScreen.currentValue;
    }
    if (changes.playerConfig.firstChange && this.isInitialized) {
      // Calling for web component explicitly and life cycle works in different order
      this.ngOnInit();
    }
  }
  ngAfterViewInit() {
    const epubPlayerElement = this.epubPlayerRef.nativeElement;
    this.unlistenMouseEnter = this.renderer2.listen(epubPlayerElement, 'mouseenter', () => {
      this.showControls = true;
    });

    this.unlistenMouseLeave = this.renderer2.listen(epubPlayerElement, 'mouseleave', () => {
      this.showControls = false;
    });
  }

  headerActions(eventdata) {
    this.headerActionsEvent.emit(eventdata);
  }
  
  onPlaybackRateChange(event: any) {
    this.playbackRate = parseFloat(event.target.value);
    if (this.audio) {
      this.audio.playbackRate = this.playbackRate;
    }
  }

  handleNotification() {
    this.handleButtonstop();
    
  }
  
  handleButtonplay(){
    this.audio.play();
  }

  handleButtonpause(){
    this.audio.pause();
  }
  handleButtonstop() {
    if (this.audio && typeof this.audio.pause === 'function') {
      this.audio.pause();
      this.audio.src = '';
      this.isStreamIntrupted = true;
      this.counter = 0;
      this.playerState.isPlaying = false;
    } 
    this.cancelRequests();
    this.audioQueue = [];
  }
  getModelId(languageCode:string) {
    if(languageCode =='unknown'){
      this.toastrService.show('Sorry, we are currently unable to provide Audio for this document.', 'error');
    }
    const language = this.languageList.find(lang => lang.languageCode === languageCode);
    return language ? language.modelId : null;
  }

  async detectLanguage(chunk: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        Authorization:
          'Rl1KVAwFU5lUDH2fLfJ_4EJrroYZUGhG06oJbWemJOC3pFw9XA0tVpqKhroKQirW',
      });
      const payload ={
        config:
        {
          serviceId:"bhashini/iiiith/indic-lang-detection-all"
        },
        input: [
            {
            source: chunk
            }
            ]
      };
  
      this.http.post(this.urlDetectLang, payload,{headers}).subscribe(
        (res: any) => {
           this.langCode = res.output[0].langPrediction[0].langCode;
          const modelId = this.getModelId(this.langCode);
          resolve(modelId);
         
        },
        error => {
          console.error('Error detecting language:', error);
          this.toastrService.show('Something Went Wrong','error')
          resolve(null); // Resolve with null if there's an error
        }
      );
    });
  }
  
  async handleButtonClick(gender: any) {
    this.toastrService.show('Please wait , Audio Processing...','info')
    this.isStreamIntrupted = false;
    this.audioQueue = [];
    let epubjsId = document.querySelector('[id^="epubjs-view-"]').id;
    if (epubjsId) {
      let epubHTML = document.getElementById(epubjsId).getAttribute("srcdoc");
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(epubHTML, "text/html");
      let hTags = htmlDoc.querySelector("body");
  
      if (hTags) {
       let speechText =this.extractTextFromElement(hTags)
        this.chunks = this.chunkText(speechText, 250);
       
        if(!this.chunks || this.chunks.length === 0){
          this.toastrService.show('Text is unavailable in current Page','error')
        }
        
        // Detect language with the first chunk
        const serviceId = await this.detectLanguage(this.chunks[0]);
        for (let i = 0; i < this.chunks.length; i++) {
          if (!this.isStreamIntrupted) {
            await this.processChunk(this.chunks[i], gender,serviceId);
          } else {
            this.chunks = [];
            break;
          }
        }
      }
    } else {
      console.log("No epubjsId found");
    }
  }

  extractTextFromElement(element) {
    if (!element) return "";

    let text = "";
    element.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            text += node.textContent.trim() + " ";
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            text += this.extractTextFromElement(node);
        }
    });
    return text.trim();
}
  
  
async processChunk(chunk: string, gender: any, serviceId: string | null) {
  if (!serviceId) {
    console.error('Model ID not found.');
    return;
  }

  const headers = new HttpHeaders({
    Authorization:
      'Rl1KVAwFU5lUDH2fLfJ_4EJrroYZUGhG06oJbWemJOC3pFw9XA0tVpqKhroKQirW',
  });

  const payload = {
    pipelineTasks: [
      {
        taskType: 'tts',
        config: {
          language: {
            sourceLanguage: this.langCode,
          },
          serviceId: serviceId,
          gender: gender,
          speed: 1,
          samplingRate: 16000,
        },
      },
    ],
    inputData: {
      input: [
        {
          source: chunk,
        },
      ],
    },
  };

  try {
    // Use RxJS to handle cancellation
    const response: any = await this.http
      .post(this.urlTTS, payload, { headers })
      .pipe(takeUntil(this.cancelRequests$)) 
      .toPromise();
    if(response){
    const audioContent = response.pipelineResponse[0].audio[0].audioContent;
    const base64Audio = audioContent;
    const audioUrl = 'data:audio/mp3;base64,' + base64Audio;
    this.audioQueue.push(audioUrl);

    if (!this.playerState.isPlaying) {
      this.playNextAudio();
    }
  }
  } catch (error) {
      this.loading = false;
      this.toastrService.show('Something Went Wrong', 'error');
  }
}


cancelRequests() {
  this.cancelRequests$.next(); 
  this.cancelRequests$.complete(); 
  this.cancelRequests$ = new Subject<void>(); 
}

playNextAudio() {
  if (this.audioQueue.length > 0 && !this.isStreamIntrupted) {
    this.loading = false;
    const audioUrl = this.audioQueue[this.counter++]; 
    
    this.audio = new Audio(audioUrl);
    this.audio.controls = true;
    this.audio.playbackRate = this.playbackRate;
    
    this.playerState.isPlaying = true;
    this.audio.play();
    this.audio.addEventListener('ended', () => {
      this.playerState.isPlaying = false;
      this.playNextAudio();
    });
  }
   else {
    this.playerState.isPlaying = false;
  }
}
  
chunkText(text: string, chunkSize: number): string[] {
  const chunks: string[] = [];
  if (!text) return chunks;

  let startIndex = 0;

  while (startIndex < text.length) {
    let endIndex = Math.min(startIndex + chunkSize, text.length);

    // Ensure we don't split a word
    if (endIndex < text.length && text[endIndex] !== ' ') {
      while (endIndex > startIndex && text[endIndex] !== ' ') {
        endIndex--;
      }

      // If no space was found, set endIndex to chunkSize
      if (endIndex === startIndex) {
        endIndex = Math.min(startIndex + chunkSize, text.length);
      }
    }

    chunks.push(text.substring(startIndex, endIndex).trim());
    startIndex = endIndex + 1; // Move past the space
  }
  return chunks;
}


  viewerEvent(event) {
    if (event.type === this.fromConst.EPUBLOADED) {
      this.onEpubLoaded(event);
    }
    if (event.type === this.fromConst.PAGECHANGE) {
      this.onPageChange(event);
    }
    if (event.type === this.fromConst.END) {
      this.onEpubEnded(event);
    }
    if (event.type === this.fromConst.ERROR) {
      this.onEpubLoadFailed(event);
    }
    if (event.type === this.fromConst.NAVIGATE_TO_PAGE) {
      this.onJumpToPage(event);
    }
    if (event.type === this.fromConst.INVALID_PAGE_ERROR) {
      this.validPage = event.data;
      this.resetValidPage();
    }
  }

  resetValidPage() {
    setTimeout(() => {
      this.validPage = true;
    }, 5000);
  }

  onEpubLoaded(event) {
    clearInterval(this.intervalRef);
    this.viewState = this.fromConst.START;
    this.viwerService.raiseStartEvent(event.data);

    if (this.playerConfig.config?.pagesVisited?.length && this.playerConfig.config?.currentLocation) {
      this.currentPageIndex = this.playerConfig.config.pagesVisited[this.playerConfig.config.pagesVisited.length - 1];
    }
    this.viwerService.metaData.pagesVisited.push(this.currentPageIndex);
  }

  onPageChange(event) {
    if (event?.data?.index) {
      this.currentPageIndex = event.data.index;
    }
    this.currentPageIndex = this.utilService.getCurrentIndex(event, this.currentPageIndex);
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.INTERACT);
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.IMPRESSION);
    this.viwerService.metaData.pagesVisited.push(this.currentPageIndex);
  }

  onJumpToPage(type) {
    this.currentPageIndex = type?.event?.data;
    this.viwerService.raiseHeartBeatEvent(type, telemetryType.INTERACT);
    this.viwerService.raiseHeartBeatEvent(type, telemetryType.IMPRESSION);
    this.viwerService.metaData.pagesVisited.push(this.currentPageIndex);
  }

  onEpubEnded(event) {
    this.handleButtonstop();
    this.viewState = this.fromConst.END;
    this.showEpubViewer = false;
    event.data.index = this.currentPageIndex;
    this.viwerService.raiseEndEvent(event);
  }

  onEpubLoadFailed(error) {
    this.showContentError = true;
    this.viewState = this.fromConst.LOADING;
    // tslint:disable-next-line:max-line-length
    this.viwerService.raiseExceptionLog(error.errorCode, this.currentPageIndex, error.errorMessage, this.traceId, new Error(error.errorMessage));
  }

  replayContent(event) {
    this.currentPageIndex = 1;
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.INTERACT);
    this.viewState = this.fromConst.START;
    this.viwerService.metaData.pagesVisited.push(this.currentPageIndex);
    this.ngOnInit();
  }

  exitContent(event) {
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.INTERACT);
  }

  sideBarEvents(event) {
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.INTERACT);
    if (event.type === 'DOWNLOAD') {
      this.downloadEpub();
    }
  }

  sidebarMenuEvent(event) {
    this.viwerService.raiseHeartBeatEvent(event, telemetryType.INTERACT);
  }

  getEpubLoadingProgress() {
    this.intervalRef = setInterval(() => {
      if (this.progress < 95) {
        this.progress = this.progress + 5;
      }
    }, 10);
  }

  downloadEpub() {
    const a = document.createElement('a');
    a.href = this.viwerService.artifactUrl;
    a.download = this.viwerService.contentName;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
    this.viwerService.raiseHeartBeatEvent('DOWNLOAD');
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.handleButtonstop();
    const EndEvent = {
      type: this.fromConst.END,
      data: {
        index: this.currentPageIndex
      }
    };
    this.viwerService.raiseEndEvent(EndEvent);
    this.viwerService.isEndEventRaised = false;
    this.unlistenMouseEnter();
    this.unlistenMouseLeave();
  }

  // Function to play next content
  playNextContent(event) {
    this.viwerService.raiseHeartBeatEventNew(event?.type, telemetryType.INTERACT, pageId.endPage, event?.identifier);
  }
}
